import { fetchInsightsMail } from '../../adminApi';
import { dayShort } from '../../../core/format/dates';
import { share } from '../../../core/rules/insights/stats';
import { ChartFrame } from '../charts/ChartFrame';
import { BarChart } from '../charts/BarChart';
import { ReportView } from '../ReportView';
import { useReport } from '../useReport';
import { fmt } from '../insightFormat';
import { seriesLabel } from '../insightLabels';
import type { PeriodState } from '../../sales/usePeriodParams';

/** Nieuwsbrief en automatische mails (Brevo), met wat "verlaten mand" alsnog opleverde. */
export function MailBlock({
  period
}: {
  period: PeriodState;
}) {
  const report = useReport(fetchInsightsMail, period.from, period.to);
  const span = `${period.from}-${period.to}`;
  return <ReportView report={report} what="De mailcijfers" integration="brevo" data-id="element-1882" data-mp="381a4mie5jdmb">
      {m => {
      const sent = [...m.newsletters].sort((a, b) => a.sentAt.localeCompare(b.sentAt));
      return <>
            <ChartFrame title="Nieuwsbrieven" description="Per verstuurde nieuwsbrief. Geklikt is betrouwbaarder dan geopend (Apple Mail telt elke mail als geopend)." fileName={`nieuwsbrieven-${span}`} table={{
          columns: [{
            label: 'Onderwerp'
          }, {
            label: 'Verstuurd',
            kind: 'text'
          }, {
            label: 'Ontvangers'
          }, {
            label: 'Geopend',
            kind: 'pct'
          }, {
            label: 'Geklikt',
            kind: 'pct'
          }, {
            label: 'Afgemeld'
          }, {
            label: 'Onbestelbaar'
          }, {
            label: 'Bestellingen'
          }, {
            label: 'Omzet',
            kind: 'money'
          }],
          rows: sent.map(n => [n.subject, dayShort(n.sentAt.slice(0, 10)), n.stats.recipients, share(n.stats.opened, n.stats.recipients), share(n.stats.clicked, n.stats.recipients), n.stats.unsubscribed, n.stats.bounced, n.stats.orders, n.stats.revenueCents])
        }} data-id="element-1883" data-mp="3ec5ak4kcwbxh">
              <BarChart empty="Geen nieuwsbrief verstuurd in deze periode." bars={sent.map(n => ({
            key: n.id,
            label: dayShort(n.sentAt.slice(0, 10)),
            values: [share(n.stats.clicked, n.stats.recipients) ?? 0]
          }))} series={[{
            label: 'Geklikt',
            className: 'bg-clay/75'
          }]} format={n => fmt(n, 'pct')} data-id="element-1884" data-mp="1o2ga02jxv18z" />
            </ChartFrame>

            <ChartFrame title="Automatische mails" description="Alsnog betaald = dezelfde klant betaalde binnen 72 uur na de mail (de server telt dat, zonder meetpixel)." tableOnly fileName={`automatische-mails-${span}`} table={{
          columns: [{
            label: 'Mail'
          }, {
            label: 'Verstuurd'
          }, {
            label: 'Geopend',
            kind: 'pct'
          }, {
            label: 'Geklikt',
            kind: 'pct'
          }, {
            label: 'Alsnog betaald'
          }],
          rows: m.series.map(s => [seriesLabel[s.key], s.sent, share(s.opened, s.sent), share(s.clicked, s.sent), s.recovered])
        }} data-id="element-1885" data-mp="271kh35rx6ky0" />
          </>;
    }}
    </ReportView>;
}